import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { IReportFilter } from "../../../utils/interfaces/report-filter";
import { IResponse } from "../../../utils/interfaces/response";
import { IReservationReport } from "../../../utils/interfaces/reservation-report";
import { map, Observable } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })

export class ReservationReportService {
    private readonly URI_API = environment.apiConfig.uri;

    constructor(private readonly httpClient: HttpClient) { }

    getReservationReport(filter: IReportFilter): Observable<IResponse<IReservationReport[]>> {
        return this.httpClient.post<IResponse<IReservationReport[]>>(
            `${this.URI_API}ReservationDish/reservation`,
            filter
        );
    }

    getReservationReportXlsx(filter: IReportFilter): Observable<Blob> {
        return this.httpClient.post(
            `${this.URI_API}ReservationDish/export`,
            filter,
            { responseType: 'blob' }
        );
    }

}